import React from 'react';

import Heading from '../../Heading';
import styles from '../FooterSimplified.module.scss';

const FooterSimplifiedBlockTitle = props => (
  <Heading
    level={2}
    theme="dark"
    size="small-medium"
    type="uppercase"
    align="left"
    className={styles.footer__title}
    {...props}
  />
);

export default FooterSimplifiedBlockTitle;
